export interface ServicesConfig {
    aim: AimConfig;
    automatic?: boolean;
}

export interface AimConfig {
    url: string;
    token: string;
    automatic?: boolean;
}

export enum AppService {
    Aim = 'aim',
}